import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/_core/services/api.service';
import { ProductItem, ProductParameters } from 'src/app/_core/models/product-parameters.model';
import { ProjectService } from 'src/app/_core/services/project.service';
import { ProjectTemplate } from 'src/app/_core/template';
import { AuthObserver, AuthService } from 'src/app/_core/services/auth.service';
import { ICrmObserver, CrmService } from 'src/app/_core/services/crm.service';
import { ProjectStoreModel } from 'src/app/_core/models/project-store/project-store.model';
import { COUNTRIES, SNOW_ZONES, UrlParams, WIND_ZONES, WIND_ZONES_TRANSLATIONS } from 'src/app/_core/constants/constants';
import { NotifyService } from 'src/app/_core/services/notify.service';
import { IProjectInfo, ProjectInfo } from 'src/app/_core/interfaces/IProjectInfo';
import { environment } from 'src/environments/environment.test';

@Component({
	selector: 'app-wizard',
	templateUrl: './wizard.dialog.html',
	styleUrls: ['./wizard.dialog.scss']
})
export class WizardDialog implements OnInit, OnDestroy, AuthObserver, ICrmObserver {
	public result;

	private middle_Height: number = 325;
	private top_Height: number;
	private bottom_Height: number;
	public container_Height: number;

	showLoading: boolean = true;
	exceptionId: string;
	exceptionMessage: string;

	private _climZoneMode: "PostalCode" | "Manual" = "PostalCode";
	infoOpened: boolean;
	infoMessage: string;
	get climateZoneMode() {
		return this._climZoneMode;
	}
	set climateZoneMode(v: "PostalCode" | "Manual") {
		this.snowZone = "";
		this.windZone = null;
		this.zipCode = "";
		if (this._climZoneMode != v && v == "Manual") {
			this.snowZone = SNOW_ZONES[this.country][0];
			this.windZone = WIND_ZONES[this.country][0];
		}
		this._climZoneMode = v;
	}

	countries = COUNTRIES;
	snowZoneValues: string[] = [];
	windZoneValues: any[] = [];

	loadingMessage: string = $localize`:Wizard|'Loading product' banner:Loading product. Please wait...`;
	crmPresent: boolean;

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.bottom_Height = window.screen.height / 10;
		this.top_Height = window.screen.height / 5;
		this.container_Height = this.bottom_Height + this.top_Height + this.middle_Height;
	}

	public opened = false;
	public showLoader = false;
	public loaderComplate = false;

	productId: string;
	brandName: string = "Aluterr";
	orderCode: string = this.projectService.info.orderCode;
	clientId: string = "";
	pwd: string = "";
	wrongPwd: boolean = false;
	orderCodeDisabled: boolean = false;
	isB2BCustomer: boolean = false;
	product: ProductParameters = new ProductParameters();

	country: string = COUNTRIES[0];
	snowZone: string;
	windZone: string;

	noProductMessage:boolean;
	authStatus: boolean = false;

	products: ProductItem[] = [];
	currentProductId: string;
	currentProductName: string;

	private _zipCode: string = "";
	get zipCode() {
		return this._zipCode;
	}
	set zipCode(v: string) {
		if (v != this._zipCode && parseInt(v) >= 10000 && parseInt(v) <= 99999) {
			this.getClimateZones(v);
		}
		this._zipCode = v;
	}

	constructor(
		public api: ApiService,
		private activatedRoute: ActivatedRoute,
		private projectService: ProjectService,
		private authService: AuthService,
		private crmService: CrmService,
		private notif: NotifyService
	) { }

	modelLoaded(designData: ProjectStoreModel, info: IProjectInfo, images: boolean): void {
		this.opened = false;
		if (this.projectService.crmImportId) {
			this.getProducts();
		}
	}

	priceChanged(priceValue: number): void {
	}

	ngOnInit(): void {
		this.getParams();
		this.onResize();
		this.authService.attach(this);
		this.crmService.attach(this);

		this.onCountryChange(this.country);
	}

	ngOnDestroy(): void {
		this.authService.detach(this);
		this.crmService.detach(this);
	}

	authStatusChanged(authStatus: boolean): void {
		this.authStatus = authStatus
		if (this.authStatus && !this.crmPresent && !this.projectService.crmImportId) {
			this.getProducts();
		}
	}

	getClimateZones(code: string) {
		this.api.getClimateZones(code).subscribe(z => {
			if (!z) {
				console.log('Błąd pobierania stref');
			} else {
				this.windZone = z.windZone;
				this.snowZone = z.snowZone;
				if (WIND_ZONES[this.country].indexOf(this.windZone) < 0) {
					this.windZone = WIND_ZONES[this.country][0];
					console.log(`Strefa wiatrowa ${z.windZone} nie istnieje; przyjęto strefę ${this.windZone}`);
					this.infoMessage = $localize`:Wizard|'Invalid wind zone' message:Invalid wind zone. Default zone have been set`;
					this.infoOpened = true;
				}
				if (SNOW_ZONES[this.country].indexOf(this.snowZone) < 0) {
					this.snowZone = SNOW_ZONES[this.country][0];
					console.log(`Strefa śniegowa ${z.snowZone} nie istnieje; przyjęto strefę ${this.snowZone}`);
					this.infoMessage = $localize`:Wizard|'Invalid snow zone' message:Invalid snow zone. Default zone have been set`;
					this.infoOpened = true;
				}
			}
		})

	}

	public start() {
		this.showLoader = true;

		var pr = new ProjectTemplate(false);
		pr.productId = this.productId;
		pr.brandName = this.brandName;
		pr.productName = this.product.name;
		pr.productPhoto = this.product.photo
		pr.version = this.product.version;
		pr.isDraft = this.product.isDraft;
		pr.errors = this.product.errors;
		pr.backHeight = this.product.height;
		pr.depth = this.product.depth;
		pr.dropAngle = this.product.dropAngle;
		pr.maxBackHeight = this.product.maxBackHeight;
		pr.minBackHeight = this.product.minBackHeight;
		pr.maxDepth = this.product.maxDepth;
		pr.minDepth = this.product.minDepth;
		pr.maxDropAngle = this.product.maxDropAngle;
		pr.minDropAngle = this.product.minDropAngle;
		pr.width = this.product.width;
		pr.maxWidth = this.product.maxWidth;
		pr.minWidth = this.product.minWidth;
		pr.snowZone = this.snowZone;
		pr.windZone = this.windZone;
		pr.country = this.country;
		this.projectService.b2bCustomerMode = this.isB2BCustomer;
		this.projectService.templateChangedSubject.subscribe(e => {
			this.opened = false;
			this.projectService.info = new ProjectInfo({
				orderCode: this.orderCode,
				externalId: this.clientId,
				postalCode: this.zipCode,
				userId: this.authService.user?.eMail,
			})
		});

		this.projectService.setupTemplate(pr);

	}

	public show() {
		this.opened = true;
	}

	public hide() {
		this.opened = false;
	}

	getParams() {
	 	this.activatedRoute.queryParams
			.subscribe(params => {
				this.productId = params[UrlParams.ProductId];	
				this.brandName = params[UrlParams.BrandName] ?? "Aluterr";
				this.crmPresent = params[UrlParams.AffinityId] != null && params[UrlParams.AffinityId] != '';
				let oc: string = params[UrlParams.OrderCode];


				const parCountry = params[UrlParams.Country];
				if (parCountry && this.countries.indexOf(parCountry.toUpperCase()) >= 0) {
					this.country = parCountry.toUpperCase();
				}

				const parSnow = params[UrlParams.SnowZone];
				if (parSnow && this.snowZoneValues.indexOf(parSnow) >= 0) {
					this.snowZone = parSnow;
				}

				const parWind = params[UrlParams.WindZone];
				if (parWind && this.windZoneValues.indexOf(parWind) >= 0) {
					this.windZone = parWind;
				}

				if (oc && oc.length > 13 && oc.length < 17) {
					this.orderCode = oc;
					this.orderCodeDisabled = true;
				} else {
					this.orderCode = "";
					this.orderCodeDisabled = false;
				}

				if (this.productId && !this.projectService.crmImportId) {
					this.projectService.productId = this.productId;
					this.getProductParameters(true);
					this.noProductMessage=false;
				} else {
					this.showLoading = true;
				}
			});
	}

	private getProducts() {
		this.api.getProducts().subscribe(p => {
			this.products = p.products;
			this.isB2BCustomer = p.isB2BCustomer;
			if (this.isB2BCustomer) {
				this.country = p.country;
				this.middle_Height = 325;
			} else {
				this.climateZoneMode = "Manual";
				this.middle_Height = 225;
			}
			this.onResize();
			if (p.products.length > 0) {
				this.currentProductId = p.products[0].productConfigurationId;
				this.currentProductName = p.products[0].productName;
				this.brandName = p.products[0].brandName;
				this.productId = this.currentProductId;
				this.projectService.productId = this.currentProductId;
				this.getProductParameters(false);
				this.showLoading = false;
			}
			if (environment.localhost) {
				this.snowZone = this.snowZoneValues[0];
				this.windZone = WIND_ZONES[this.country][0];
				this.orderCode = "TESTORDER12345";
				this.clientId = "TESTCLIENT";
			}

		});

	}

	public isValid(): boolean {
		const orderOk = !this.isB2BCustomer && (this.orderCode.length > 13 && this.orderCode.length < 17);
		const clientOk = this.isB2BCustomer && this.clientId.trim() != "";
		return (orderOk || clientOk)
				&& SNOW_ZONES[this.country].indexOf(this.snowZone) >= 0
				&& WIND_ZONES[this.country].indexOf(this.windZone) >= 0;
	}


	onCountryChange(event) {
		if (!event || !this.countries.includes(event)) {
			return;
		}
		this.snowZoneValues = SNOW_ZONES[event];
		this.getWindZones(event);
	}

	getWindZones(arg0: string) {
		this.windZoneValues = [];
		WIND_ZONES[arg0].forEach(wz => {
			this.windZoneValues.push({ zone: wz, label: WIND_ZONES_TRANSLATIONS.get(wz) ?? wz });
		});
	}

	onProductChange(productId: string) {
		const selected = this.products.find(p => p.productConfigurationId === productId);
		if (!selected) {
			return;
		}
		this.productId = productId;
		this.currentProductName = selected.productName;
		this.brandName = selected.brandName;
		this.projectService.productId = productId;
		this.getProductParameters(false);
	}

	getProductParameters(toClear: boolean) {
		if (!this.opened) {
			return;
		}
		this.showLoading = true;
		this.api.getProductParameters(this.productId, this.brandName).subscribe(response => {			
			if (!response.isActive && !this.crmPresent) {
				this.hide();
				this.notif.cfgException.emit(
					{ 
						message: $localize`:Common|'Product is inactive' message:This product is inactive. Cannot create new project.`,
						clear: toClear
					});
				return;
			}

			this.product = response;
			this.product.width = this.product.defaultWidth;
			this.product.height = this.product.defaultBackHeight;
			this.product.depth = this.product.defaultDepth;
			this.product.dropAngle = this.product.defaultDropAngle;
			this.showLoading = false;
		},error=>{
			this.noProductMessage = true;
			this.exceptionId = error.error.exceptionId;
			this.exceptionMessage = error.error.message;
		})
	}

	public onInfoClosed() {
		this.infoOpened = false;
	}
}
